import { useCallback, useEffect, useRef } from 'react'
import { Animated } from 'react-native'
import { playSound } from '../../../utils/audioService'
import { useStore } from '../../../models'

export const useFlip = (show: boolean, makeSound = false) => {
  const flipAnimation = useRef(new Animated.Value(0)).current
  const {
    permissions: { isSoundEnabled }
  } = useStore()
  const flipToFrontStyle = {
    transform: [
      {
        rotateY: flipAnimation.interpolate({
          inputRange: [0, 180],
          outputRange: ['0deg', '180deg']
        })
      }
    ]
  }
  const flipToBackStyle = {
    transform: [
      {
        rotateY: flipAnimation.interpolate({
          inputRange: [0, 180],
          outputRange: ['180deg', '360deg']
        })
      }
    ]
  }

  const flipToFront = useCallback(() => {
    Animated.timing(flipAnimation, {
      toValue: 180,
      duration: 300,
      useNativeDriver: true
    }).start()
  }, [flipAnimation])

  const flipToBack = useCallback(() => {
    Animated.timing(flipAnimation, {
      toValue: 0,
      duration: 300,
      useNativeDriver: true
    }).start()
  }, [flipAnimation])

  useEffect(() => {
    if (show) {
      if (isSoundEnabled && makeSound) {
        playSound('cardsDealt')
      }

      flipToFront()
    } else {
      flipToBack()
    }
  }, [show, flipToFront, flipToBack, makeSound])

  return {
    flipToBackStyle,
    flipToFrontStyle
  }
}
